import { queryOptions } from '@tanstack/react-query';
import { client } from '#queries/utils';
import { registerBaseURL } from '#constants/hosts';
import { ApiGetOrganizationResponse } from '#proto/qonto/registration/organizations/firstparty/v1/get_organization';
import { ApiListOrganizationsResponse } from '#proto/qonto/registration/organizations/firstparty/v1/list_organizations';
import { unwrapResponse } from '../../utils/unwrap-response';

export const registerOrganizationQueries = {
  all: ['register-organizations'] as const,
  lists: () => [...registerOrganizationQueries.all, 'list'] as const,
  items: () => [...registerOrganizationQueries.all, 'item'] as const,
  list: () =>
    queryOptions({
      queryKey: [...registerOrganizationQueries.lists()] as const,
      queryFn: async () => {
        const json = await client(`${registerBaseURL}/v1/organizations`);
        return ApiListOrganizationsResponse.fromJSON(json).organizations;
      },
    }),
  listEmbed: () =>
    queryOptions({
      queryKey: [...registerOrganizationQueries.all, 'list-embed'] as const,
      queryFn: async () => {
        const json = await client(
          `${registerBaseURL}/v1/organizations?embed_contract_signed=true&include=registration`
        );
        return ApiListOrganizationsResponse.fromJSON(json).organizations;
      },
    }),
  item: (id: string) =>
    queryOptions({
      queryKey: [...registerOrganizationQueries.items(), id] as const,
      queryFn: async () => {
        const json = await client(`${registerBaseURL}/v1/organizations/${id}`);
        return unwrapResponse(ApiGetOrganizationResponse.fromJSON(json), 'organization');
      },
    }),
  recommendedPricePlan: (organizationId: string) =>
    queryOptions({
      queryKey: [
        ...registerOrganizationQueries.all,
        'recommended-price-plan',
        organizationId,
      ] as const,
      queryFn: async () => {
        const response = await client<{ price_plan?: string }>(
          `${registerBaseURL}/v1/organizations/${organizationId}/recommended_price_plan`
        );
        return response.price_plan ?? null;
      },
      enabled: Boolean(organizationId),
    }),
};
